import React, { ReactNode, FC } from 'react';
import { Menu, Dropdown } from 'antd';
import { MenuProps } from 'antd/lib/menu';
import styled from 'styled-components';

import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import SvgIcon from '~src/shared/SvgIcon';

import IconTextMenuItem from './IconTextMenuItem';
import { MenuItem } from './DropdownBtn.sc';

const Wrapper = styled.div.attrs({ 'data-testid': 'DropdownBtnWrapper' })`
  height: 43px;

  > button:first-child {
    height: 43px;
  }

  .ant-dropdown-trigger {
    svg {
      transition: transform 250ms;
    }

    &.ant-dropdown-open svg {
      transform: rotate(180deg);
    }
  }
`;

export const DdMenu = styled(Menu)<{ children: ReactNode } & MenuProps>`
  padding: 0;
  overflow: hidden;
  border-radius: 5px;

  .ant-dropdown-menu-item {
    &:hover {
      background-color: ${({ theme }) => theme.baseBlue.a10};
      color: ${({ theme }) => theme.white.a10};
    }
  }

  li:last-child > div {
    border: 0;
  }
`;

export const StyledMenuItem = styled(Menu.Item)`
  padding: 0;

  &:hover {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    color: ${({ theme }) => theme.white.a10};

    &:first-child {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    &:last-child {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    :hover {
      background-color: ${({ theme }) => theme.baseBlue.a10};
      color: ${({ theme }) => theme.white.a10};
    }
  }
`;

const SubItemContainer = styled(Menu.SubMenu)`
  padding: 0;

  > ul {
    padding: 0;
  }

  li:last-child > div {
    border: 0;
  }

  .ant-dropdown-menu-submenu-title {
    padding: 0;
    border-radius: 5px;

    :hover {
      background-color: ${({ theme }) => theme.baseBlue.a10};
      color: ${({ theme }) => theme.white.a10};
    }

    .ant-dropdown-menu-submenu-arrowr, .ant-dropdown-menu-submenu-expand-icon {
      display: none;
    }
  }
`;

const BtnTxt = styled.span`
  padding-right: 7px;
`;

interface OwnProps {
  btnTxt: string;
  menuItems: MenuItem[];
  withBorder?: boolean;
  translationKey?: string;
  height?: string | number;
}

const DropdownBtn: FC<OwnProps> = React.memo(function DropdownBtn({ btnTxt, menuItems, withBorder, translationKey, height }) {
  const menu = (
    <DdMenu>
      {menuItems.map((item) =>
        item.subMenu && item.subMenu ? (
          // @ts-expect-error TS-18048
          <SubItemContainer key={item.text.key} title={<IconTextMenuItem arrow {...item} />}>
            {item.subMenu.items.map((subItem) => (
              <StyledMenuItem key={subItem.id} onClick={subItem.onClick}>
                {subItem.node}
              </StyledMenuItem>
            ))}
          </SubItemContainer>
        ) : (
          <StyledMenuItem key={item.text?.key} onClick={item.onClick}>
            {item.node ? item.node : <IconTextMenuItem {...item} />}
          </StyledMenuItem>
        ),
      )}
    </DdMenu>
  );

  return (
    <Wrapper>
      <Dropdown overlay={menu} trigger={['click']} overlayClassName="lls-dropdown-menu" placement="bottom">
        <PrimaryButton
          style={{ height: height }}
          $buttonColor="blue"
          $buttonSize="medium"
          $withBorder={withBorder}
        >
          <BtnTxt data-translation={translationKey}>{btnTxt}</BtnTxt>
          <SvgIcon name="iconDropDownArrow" width={12} />
        </PrimaryButton>
      </Dropdown>
    </Wrapper>
  );
});

export default DropdownBtn;
